export default "__VITE_ASSET__Ddp5kQiJ__"